import CloudinaryImage from "@/components/cloudinary-image";
import ModalCloseIcon from "@/components/icons/modal-close-icon";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { formatDateDisplay } from "@/helpers/parsers";

import type { BadgeType } from "../../types";

interface DetailsModalProps extends React.ComponentProps<typeof Dialog> {
  badge: BadgeType;
}

export default function DetailsModal({ badge, ...props }: DetailsModalProps) {
  return (
    <Dialog {...props}>
      <DialogContent
        className="rounded-t-[15px] bg-[url(/images/main-bg.jpg)] bg-cover bg-top bg-no-repeat px-5 py-7.5 shadow-0-0-20 shadow-black/30"
        overlayClassName="bg-gray-cool/64"
      >
        <Button
          aria-label="Close"
          className="absolute top-5 left-5 flex size-[25px] items-center justify-center rounded-full border border-white"
          onClick={() => props.onOpenChange?.(false)}
        >
          <ModalCloseIcon />
        </Button>
        <div className="flex flex-col items-center gap-[15px]">
          <CloudinaryImage
            alt={badge.name}
            className="size-30"
            imageId={badge.image || ""}
            rW={256}
          />
          <h4 className="text-center font-medium text-16/[1.5em]">
            {badge.name}
          </h4>
          {!!badge.earnedAt && (
            <h5 className="text-center font-normal text-13/[1.5em] text-white/50">
              Unlocked on {formatDateDisplay(badge.earnedAt)}
            </h5>
          )}
          <p className="text-center text-14/[1.7em] text-pale-lavender">
            {badge.description}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
